export class SimpleCache<K, V> {
    private cache: Map<string, V>;
    private keyGenerator: (keyObj: K) => string;
    private maxSize: number;

    constructor(keyGenerator: (keyObj: K) => string, maxSize: number = 10) {
        if (maxSize === 0) {
            throw new Error("maxSize must be greater than 0");
        }
        this.cache = new Map<string, V>();
        this.keyGenerator = keyGenerator;
        this.maxSize = maxSize;
    }

    get(keyObj: K): V | undefined {
        const key = this.keyGenerator(keyObj);
        return this.cache.get(key);
    }

    set(keyObj: K, value: V): void {
        const key = this.keyGenerator(keyObj);
        this.cache.delete(key);
        this.cache.set(key, value);
        if (this.cache.size > this.maxSize) {
            const oldestKey = this.cache.keys().next().value!;
            this.cache.delete(oldestKey);
        }
    }

    delete(keyObj: K): boolean {
        const key = this.keyGenerator(keyObj);
        return this.cache.delete(key);
    }

    clear(): void {
        this.cache.clear();
    }
}
